import { useParams } from 'react-router-dom'
import _ from 'underscore'
import styled from 'styled-components'

import FeatureTour from 'models/FeatureTour'

import NotFound from 'pages/NotFound'
import FeatureTourForm from 'pages/shared/FeatureTourForm'

import useFeatureTours from 'hooks/useFeatureTours'

import Brand from 'helpers/brand'

import { PageHeader, PageTitle, LoadingSinglePanePage, SinglePanePage, screenSize } from 'styles/shared'

const EditFeatureTour = () => {
  const brands = Brand.allBrandsOfCurrentBusinessUnit()
  const { featureTours, areFeatureToursLoaded } = useFeatureTours(brands, false, false)

  const { id } = useParams()

  if (!areFeatureToursLoaded) {
    return <LoadingSinglePanePage />
  }

  const featureTour = _.find(featureTours, (featureTour) => featureTour.id.toString() === id)
  if (!featureTour) {
    return (<NotFound />)
  }

  return (
    <>
      <PageHeader>
        <S.PageTitle>Edit Feature Tour</S.PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        <FeatureTourForm
          validatedSaveType="update"
          featureTour={new FeatureTour(featureTour)}
        />
      </S.SinglePanePage>
    </>
  )
}

export default EditFeatureTour

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
